import React from 'react';

import ListViewTable from '../list/listViewTable2';
import SubpanelHeader from 'ROOT/src/components/subpanel/subpanelHeader';
import Subpanel_orig from 'ROOT/src/components/subpanel/subpanel';
import Loader from 'ROOT/src/components/loader';

export default class Subpanel extends Subpanel_orig {
    render() {
        const data = this.props.data;
        const way = this.props.way;
        let records = 0;
        try {
            records = data.rows.rows.get(0).records.size;
        } catch (e) {}

        const page = data && data.rows && data.rows.page ? data.rows.page : 1;


        let openSubpanel = false;
        if (page != 1 || records > 0 ||
    data.rows.actFiltering == true || data.rows.listViewTree.module != null) {
            openSubpanel = true;
        }

        if (data.def.get('open') === false) {
            openSubpanel = false;
        }

        const readonly = data.def.get('readonly');

        return (
            <div
                className="subpanelContainer"
                data-way={way}
                onClick={(e) => this.maxSizeClose(e)}
            >
                <div
                    className={
                        (data.def.get('show') == false ? 'subpanel hidden' : 'subpanel') +
            (openSubpanel === true ? ' expanded' : ' inLine')
                    }
                    ref={this.subpanel}
                >
                    <SubpanelHeader
                        data={data}
                        way={way}
                        prefix={this.props.prefix}
                        records={records}
                        iconColor={this.props.iconColor}
                        acl={this.props.acl}
                    />

                    {openSubpanel === true && (
                        <ListViewTable
                            data={data.rows}
                            parent={this}
                            prefix={way + '/rows'}
                            acl={this.props.acl}
                            readonly={readonly}
                        />
                    )}
                    {data.def.get('load') === true && (
                        <div className="subpanelLoader">
                            <Loader />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
